import EventItem from '../../../../../../components/Cards/CardComponents/EventItem'
import { Event } from '../../../../../../types/event'

interface EventSectionProps {
  events: Event[]
}

export function EventSection({ events }: EventSectionProps) {
  if (!events?.length) return null

  return (
    <div className="tc-mv-question-field p-4 rounded-2xl text-white space-y-2">
      <h2 className="text-xl font-semibold">Events</h2>
      <div className="space-y-8">
        {events.map((event, index) => (
          <EventItem key={index} event={event} />
        ))}
      </div>
    </div>
  )
}
